/*!
 * scripts.js
 *
 * Call any plugins and other regular JavaScript and jQuery code here.
 */

window.is_animating = false;

;(function($, window, document, undefined) {

    $(document).ready(function() {

        window.display_width_array = {

            '.module--query' : [
                {
                    'selector' : '.display-item .wrapper',
                },
                {
                    'selector' : '.display-item .content-wrap',
                }
            ],

        };

        heading_widths();
        display_heights();

        /** -----------------------------------------------------------
         *
         * Resize
         *
         * This function controls the ability to "like" a post.
         *
         * ------------------------------------------------------------ */

         $(window).on('resize', function(){

            heading_widths();
            display_heights();

            // If the window is laptop width or higher, we execute
            // the following set of commands
            if (window.matchMedia(window.media_queries.lap).matches) {

                // Remove inline display on any sub navigations
                $('.nav--sub').css('display', '');

                // Remove inline display on the sidebar navigation
                $('.nav--collapsable .nav__list').css('display', '');

                // Remove the active state on any sub navigation triggers
                $('.nav__expand, .js-nav-toggle').removeClass('js-active');

            }

            $('.slider.slick-initialized').each(function(){

                slide_heights($(this));

            });

         });




        $('.dropdown__selector').on('click', toggle_dropdown);

        $('.collapsable-content__heading').on('click', toggle_collapsable_content);



        /** -----------------------------------------------------------
         *
         * Back to Top Button
         *
         * These event triggers watch for scroll and click events and
         * control the behaviour of the "back to top" button.
         *
         * ------------------------------------------------------------ */

        // Toggle visibility on scroll
        $(window).on('scroll', toggle_past_top);

        // Toggle scroll on click/touch
        $('.back-to-top').on('click touchstart', function(e){
            $('body').addClass('js-scrolling');
            e.preventDefault();
            $('body').removeClass('js-show-sticky-header js-sticky-header js-scrolled-past-fold');

            $('html, body').animate({ scrollTop: 0 }, 500, function(){

                $('body').removeClass('js-scrolling');

            });

        });



        /** -----------------------------------------------------------
         *
         * Click Off
         *
         * This function is basically used on to be able to close certain
         * elements when the user clicks outside of that element.
         *
         * ------------------------------------------------------------ */

        $('body').on('touchstart', function(e){

            var target = e.target;

            // Close nav dropdowns when clicking off of them
            if ($(target).closest('.nav--main').length < 1) {

                if (window.matchMedia('(min-width: 45em)').matches) {

                    $('.nav--main .js-hover').removeClass('js-hover');

                }

            }

        });

        $('body').on('click', function(e){

            var target = e.target;

            // Close nav dropdowns when clicking off of them
            if ($(target).closest('.dropdown').length < 1) {

                $('.dropdown.js-active').removeClass('js-active');

            }

        });


        /** -----------------------------------------------------------
         *
         * Header Click Events
         *
         * The following event listeners are intended to handle clicks
         * on objects within the header.
         *
         * ------------------------------------------------------------ */

        $('body').on('click', '.js-toggle-search', toggle_search);

        $('.js-toggle-nav').on('click', toggle_nav);

        $('.nav__expand').on('click', toggle_subnav);

        $('.nav--main a').on('touchstart', touch_subnav);

        $('.js-nav-toggle').on('click', toggle_sidebar);


        /** -----------------------------------------------------------
         *
         * Slider Configurations
         *
         * The following functions will register various sliders, as
         * they appear in the site. These use the Slick Slider library:
         *
         * http://kenwheeler.github.io/slick/
         *
         * ------------------------------------------------------------ */

          $('.slick--home').on('init', function(slick){

              slide_heights(slick);

          });

          $('.slick--home').slick({
            'speed'        : 1000,
            'appendArrows' : '.slick--home + .slider-nav .wrapper',
            'prevArrow'    : '<a type="button" class="btn slick-prev"><span class="hidden">Previous</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></a>',
            'nextArrow'    : '<a type="button" class="btn slick-next"><span class="hidden">Next</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></a>',
          });

          $('.grid--slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            'appendArrows' : '.grid--slider + .slider-nav .wrapper',
            'prevArrow'    : '<a type="button" class="btn slick-prev"><span class="hidden">Previous</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></a>',
            'nextArrow'    : '<a type="button" class="btn slick-next"><span class="hidden">Next</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></a>',
            'responsive'   : [
                {
                  breakpoint: media_query_to_pixels('lap'),
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
          });

          $('.gallery--slider').slick({
            'speed'        : 700,
            'prevArrow'    : '<a type="btn" class="slick-prev"><span class="hidden">Previous</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-left"></use></svg></a>',
            'nextArrow'    : '<a type="btn" class="slick-next"><span class="hidden">Next</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-right"></use></svg></a>',
          });


        /** -----------------------------------------------------------
         *
         * Lightbox
         *
         * Initialize the lightbox to appear on the .img-link class.
         *
         * ------------------------------------------------------------ */

        $('.img-link').magnificPopup({
          type: 'image',
          mainClass: 'mfp-with-zoom', // this class is for CSS animation below
        });

        $('.video-link').magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-with-zoom', // this class is for CSS animation below
        });

        $('.gallery--grid').magnificPopup({
            delegate: 'a',
            type: 'image',
            callbacks: {
                open: soshal_magnific_controls
            },
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                titleSrc: function(item) {
                    if(item.el.attr('title')) {
                        return item.el.attr('title');
                    }
                    else {
                        return '';
                    }
                }
            }
        });



        /** -----------------------------------------------------------
         *
         * Search
         *
         * Initialize event listeners related to search.
         *
         * ------------------------------------------------------------ */

         $('.btn--clear').on('click', function(e){

            e.preventDefault();

            var form = $(this).closest('.form--search');
            var input = $(form).find('.search-query');

            $(input).val('');

         });



        /** -----------------------------------------------------------
         *
         * Items Grid
         *
         * Initialize event listeners related to search.
         *
         * ------------------------------------------------------------ */

        $( '.module--item-grid .item--internal a' ).on('click touchstart', open_items_grid);
        $( '.module--item-grid .js-close-item' ).on('click touchstart', close_items_grid);



        /** -----------------------------------------------------------
         *
         * AJAX Event Binding
         *
         * ------------------------------------------------------------ */

        if ( window._ajax_click !== undefined ) {
            $('.js-load-posts').on('click', window._ajax_click);
        }


    });

})(jQuery, window, document);

function heading_widths() {

    $('.heading--keyline .heading__h span').each(function(){

        var heading = $(this).parent();

        heading.css('width', '');

        var width = $(this).outerWidth();
        var padding = Number(heading.css('padding-left').replace('px', '')) + Number(heading.css('padding-right').replace('px', ''));

        width = Math.ceil(width + padding + 1) + 'px';

        heading.css('width', width);

    });

}

function display_heights() {

    Object.keys(window.display_width_array).forEach(function(key) {

        $(key).each(function() {

            var module = $(this);

            var get_height = function(){

                var h = $(this).outerHeight();
                height = ( h > height ) ? h : height;

            };

            for (var x = 0; x < window.display_width_array[key].length; x++) {

                var height = 0;
                var selector = window.display_width_array[key][x].selector;

                module.find(selector).css('height', '');

                module.find(selector).each(get_height);

                module.find(selector).css('height', height + 'px');

            }

        });

    });

}

function toggle_search(e) {

    e.preventDefault();

    var body = $('body');
    body.toggleClass('js-show-search');

    if ( body.hasClass('js-show-search') ) {

        setTimeout(function() {

            $('#modal-search').focus();

        }, 100);

    }

}

function toggle_nav(e) {

    e.preventDefault();
    $('body').addClass('js-fade');

    window.fader = setTimeout(function(){

        $('body').toggleClass('js-show-nav');
        $('body').removeClass('js-fade');

    }, 350);

}

function toggle_subnav(e) {

    e.preventDefault();

    var item = $(this).closest('.nav__item');

    $(this).toggleClass('js-active');
    item.find('.nav--sub').slideToggle();

}

function touch_subnav(e) {

    var parent = $(this).parent();

    if ( parent.hasClass('nav__item--has-subnav') && ! parent.hasClass('js-hover') && window.matchMedia('(min-width: 45em)').matches ) {

        e.preventDefault();
        e.stopPropagation();

        $('.js-hover').removeClass('js-hover');
        $(this).parent().addClass('js-hover');

    }

}

function toggle_sidebar(e) {

    e.preventDefault();

    var item = $(this).closest('.nav--collapsable');

    $(this).toggleClass('js-active');
    item.find('.nav__list').slideToggle();

}

function toggle_dropdown(e) {

    e.preventDefault();

    var dropdown = $(this).closest('.dropdown');
    dropdown.toggleClass('js-active');

}

function toggle_collapsable_content(e) {

    e.preventDefault();

    $(this).parent().toggleClass('js-active');

    if ( $(this).parent().hasClass('js-active') ) {

        var content = $(this).parent().find('.collapsable-content__content-interior');
        var height = content.outerHeight();

        content.parent().css('height', height + 'px');

    }

    else {

        $(this).parent().find('.collapsable-content__content').css('height', '');

    }

}

function open_items_grid(e) {

    e.preventDefault();

    if ( window.is_animating ) {

        return false;

    }

    window.is_animating = true;

    var module = $(this).closest('.module');
    var grid   = $(this).closest('.grid');
    var item   = $(this).closest('.grid__item');
    var scroll = grid.offset();
    var back   = grid.find('.back-link');

    var wrapper_offset = grid.offset();
    var item_offset    = item.offset();

    var top  = item_offset.top - wrapper_offset.top;
    var left = item_offset.left - wrapper_offset.left;

    var item_delay = 700;
    var scroll_top = scroll.top - 54 - $('.header--sticky').outerHeight();

    var offset_top = ($(window).scrollTop() > scroll.top);
    var breakpoint = window.matchMedia(window.media_queries.lap).matches;

    if ( item.hasClass('first') ) {

        item_delay = 0;

    }

    var grid_height = grid.outerHeight();
    grid.css('height', grid_height + 'px');
    grid.attr('data-height', grid_height);

    module.addClass('js-show-internal');
    item.addClass('js-active');

    if( ! breakpoint && offset_top) {

        $('html, body').animate({ scrollTop: scroll_top }, 250);

    }

    window.delay = setTimeout(function(){

        item.css({'position' : 'absolute', 'z-index' : 10, 'top' : top + 'px', 'left' : left + 'px'});
        item.attr('data-pos-left', left);
        item.attr('data-pos-top', top);

        window.delay = setTimeout(function(){

            item.css({'top' : '0px', 'left' : '0px'});

            var internal = item.find('.internal');
            var content  = item.find('.internal__content');
            var content_height = content.outerHeight();

            if ( ! breakpoint ) {

                content_height += item.outerHeight();
            }

            if( breakpoint && offset_top) {

                $('html, body').delay(300).animate({ scrollTop: scroll_top }, 350);

            }

            if ( breakpoint && content_height < item.outerHeight() ) {

                content_height = item.outerHeight();

            }

            window.console.log(content_height);
            window.console.log(item.outerHeight());

            window.delay = setTimeout(function(){

                var back_top = (item.outerHeight() - 24) + 'px';

                internal.css({'height' : content_height + 'px'});
                grid.css({'height' : content_height + 'px'});
                back.css({'opacity' : 1, 'visibility' : 'visible', 'top' : back_top});

                window.is_animating = false;

            }, item_delay);

        }, 20);

    }, 510);

}

function close_items_grid(e) {

    e.preventDefault();

    if ( window.is_animating ) {

        return false;

    }

    window.is_animating = true;

    var module = $(this).closest('.module');
    var grid   = $(this).closest('.grid');
    var item   = module.find('.js-active');
    var back   = grid.find('.back-link');
    var internal = item.find('.internal');
    // var content  = item.find('.internal__content');

    var item_delay = 700;

    if ( item.hasClass('first') ) {

        item_delay = 0;

    }

    // Define the 'default' variable.
    // This variable will be used to reset the CSS to the baseline
    // styles that are in the actual stylesheet.
    var x = '';

    var grid_height = grid.attr('data-height');
    grid.css({'height': grid_height});

    // Close the back button and internal content

    internal.css({'height' : x});
    back.css({'opacity' : x, x : x});

    window.delay = setTimeout(function(){

        var left = item.attr('data-pos-left');
        var top = item.attr('data-pos-top');
        item.css({'top' : top + 'px', 'left' : left + 'px'});

        window.delay = setTimeout(function(){

            item.css({'position' : x, 'z-index' : x, 'top' : x, 'left' : x});
            item.removeClass('js-active');
            module.removeClass('js-show-internal');
            grid.css({'height': x});
            back.css({'top' : x});

            window.is_animating = false;

        }, item_delay);

    }, 510);
}

function toggle_past_top() {

    var body     = $('body');

    if ( body.hasClass('js-scrolling') ) {

        return false;

    }

    var viewport = $(window);
    var height   = viewport.height() * 0.3;
    var offset   = viewport.scrollTop();

    if ( offset > height ) {

        if ( ! body.hasClass('js-scrolled-past-fold') ) {

            if ( $('.header--sticky').length < 1 ) {

                var clone = $('.header--global').clone();
                clone.addClass('header--sticky');

                var html = clone.html();
                html = '<div class="header header--global header--sticky" aria-hidden="true">' + html + '</div>';

                $('body').append(html);
            }

            body.addClass('js-scrolled-past-fold');

            setTimeout(function(){

                body.addClass('js-show-sticky-nav');

            }, 320);

        }
    }

    else {

        if ( body.hasClass('js-scrolled-past-fold') ) {

            body.removeClass('js-show-sticky-nav');

            setTimeout(function(){

                body.removeClass('js-scrolled-past-fold');
                $('.header--sticky').remove();

            }, 320);

        }

    }

}

function slide_heights(slick) {

    var slider = slick;

    if ( slick.currentTarget !== undefined ) {

        slider = $(slick.currentTarget);

    }

    var min_height = 0;

    slider.find('.background-box__content').css('min-height', '').each(function(){

        var this_height = $(this).outerHeight();

        if ( this_height > min_height ) {

            min_height = this_height;

        }

    }).css('min-height', min_height);

}



function media_query_to_pixels(name) {

    var query = window.media_queries[name];

    query = query.replace('(min-width: ', '');
    query = Number(query.replace('em)', ''));

    var result = query * 16;

    return result;

}

function soshal_magnific_controls() {

    $('.mfp-arrow-left').html('<span class="hidden">Previous</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-left"></use></svg>');
    $('.mfp-arrow-right').html('<span class="hidden">Previous</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-right"></use></svg>');
    $('.mfp-close').html('<span class="hidden">Previous</span><svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use></svg>');
}
